import axios from 'axios';

axios.defaults.withCredentials = true;

export const getOperations = () => axios.post('/operations/fetch');
export const insertOperation = (operation) => axios.post( '/operations/new', operation );
export const updateOperation = (operation) => axios.post('/operations/update', operation);
export const deleteOperation = (operation) => axios.post('/operations/delete', operation);
export const bookedTransportDays = (transportMethodId) => axios.post('/operations/bookedtransportdays', {transportMethod : transportMethodId});
export const completedBydate = async(startDate,endDate) => axios.post('/operations/completedbydate', { startDate: startDate, endDate: endDate});